<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">

        <div v-if="!process">

          <v-card>
          <v-card-title class="headline text-center"> Login </v-card-title>
          <v-card-subtitle class="text-center">
            Acesse sua conta
          </v-card-subtitle>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="login.email"
                :rules="[rules.required, rules.email]"
                label="E-mail"
                required
                prepend-icon="mdi-email"
              ></v-text-field>

              <v-text-field
                v-model="login.password"
                :rules="[rules.required]"
                prepend-icon="mdi-lock"
                label="Senha"
                type="password"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn text color="primary" @click="showForgotPasswordDialog = true">
              Esqueceu a senha?
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="logar">Entrar</v-btn>
          </v-card-actions>
        </v-card>
        </div>

        <LoadingPage v-else/>

      </v-col>
    </v-row>

    <!-- Modal de Recuperação de Senha -->
    <v-dialog v-model="showForgotPasswordDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Recuperar Senha
        </v-card-title>

        <v-card-subtitle>
          Informe seu e-mail para receber o link de redefinição de senha
        </v-card-subtitle>

        <v-card-text>
          <v-form ref="forgotPasswordForm" v-model="validForgotPassword">
            <v-text-field
              v-model="forgotPasswordEmail"
              :rules="[rules.required, rules.email]"
              label="E-mail"
              required
              prepend-icon="mdi-email"
              :disabled="sendingForgotPassword"
            ></v-text-field>
          </v-form>

          <v-alert
            v-if="forgotPasswordMessage"
            :type="forgotPasswordMessageType"
            class="mt-4"
          >
            {{ forgotPasswordMessage }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            text 
            @click="closeForgotPasswordDialog"
            :disabled="sendingForgotPassword"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="primary" 
            @click="sendForgotPassword"
            :loading="sendingForgotPassword"
            :disabled="sendingForgotPassword"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import api from "@/services";
import axios from "axios";
import { EventBus } from "../main";
import LoadingPage from "@/components/LoadingPage.vue";

export default {
  components:{ LoadingPage },
  name: "LoginVuetify",
  data() {
    return {
      valid: false,
      process: false,
      login: {
        email: "",
        password: "",
      },
      showForgotPasswordDialog: false,
      validForgotPassword: false,
      forgotPasswordEmail: "",
      sendingForgotPassword: false,
      forgotPasswordMessage: "",
      forgotPasswordMessageType: "success",
      rules: {
        required: (value) => !!value || "Campo obrigatório.",
        email: (value) => {
          const pattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/;
          return pattern.test(value) || "E-mail deve ser válido.";
        },
      },
    };
  },
  methods: {
    async logar() {
      if (this.$refs.form.validate()) {
        const request = this.login;

        try {

          this.process = true;

          const { data } = await api.post("/auth/login", request);

          window.localStorage.token = `Bearer ${data.access_token}`;
          
          window.localStorage.menu = JSON.stringify(data.menu);

          /** Pega o nome do usuário */
          const axiosInstance = axios.create({
            baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
            headers: {
              Authorization: `Bearer ${data.access_token}`,
            },
          });

          const me = await axiosInstance.post("/auth/me");
          const name = me.data.name;
          if (me.data.role) window.localStorage.role = me.data.role;

          EventBus.$emit("update-logged-in-status", true, name);

          window.location.href = "./admin/dashboard";
        } catch (error) {
          console.warn(`> User/Password ${error.response.data.error}`);
          this.process = false;

          Toast.fire(
            "Atenção!",
            "E-mail ou senha não correspondem.",
            "error"
          );
        }
      }
    },

    async sendForgotPassword() {
      if (this.$refs.forgotPasswordForm.validate()) {
        this.sendingForgotPassword = true;
        this.forgotPasswordMessage = "";

        try {
          const { data } = await api.post("/forgot-password", {
            email: this.forgotPasswordEmail
          });

          this.forgotPasswordMessage = data.message;
          this.forgotPasswordMessageType = "success";

          // Limpa o formulário após 3 segundos e fecha o modal
          setTimeout(() => {
            this.closeForgotPasswordDialog();
          }, 3000);

        } catch (error) {
          console.error("Erro ao enviar e-mail de recuperação:", error);
          
          this.forgotPasswordMessageType = "error";
          this.forgotPasswordMessage = error.response?.data?.message || 
            "Erro ao enviar e-mail de recuperação. Tente novamente.";
        } finally {
          this.sendingForgotPassword = false;
        }
      }
    },

    closeForgotPasswordDialog() {
      this.showForgotPasswordDialog = false;
      this.forgotPasswordEmail = "";
      this.forgotPasswordMessage = "";
      this.sendingForgotPassword = false;
      if (this.$refs.forgotPasswordForm) {
        this.$refs.forgotPasswordForm.reset();
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.v-card-title {
  background-color: #1976d2;
  color: white;
  padding: 16px;
}

.v-card-actions .v-btn:last-child {
  width: 100%;
}
</style>
